import merge from 'lodash/merge';
import * as actions from './types';
import service from './service';

const fetchList = (search, dispatch) =>
  service
    .fetchList(search)
    .then(response => dispatch({ type: actions.FETCH_LIST, data: response.data }));

const getNewSearch = (search, getState) => {
  const { model = {} } = getState().OnlineSurveyForm;
  const { form, sort, page } = getState().OnlineSurveyStudents;
  return merge({}, { form, sort, page }, search, { form: { id: model.id } });
};

const creators = {
  sortChange: sort =>
    async (dispatch, getState) => {
      dispatch({ type: actions.SORT_CHANGE, sort });
      return fetchList(getNewSearch({ sort }, getState), dispatch);
    },
  pageChange: page =>
    async (dispatch, getState) => {
      dispatch({ type: actions.PAGE_CHANGE, page });
      return fetchList(getNewSearch({ page }, getState), dispatch);
    },
  searchFormSubmit: form =>
    async (dispatch, getState) => {
      // console.log('searchFormSubmit', form, dispatch);
      dispatch({ type: actions.SEARCH_FORM_SUBMIT, form });

      // console.log(getNewSearch({ form, page: 0 }, getState));
      return fetchList(getNewSearch({ form, page: 0 }, getState), dispatch);
    },
};

export default creators;
